import HeaderSection from "../../components/HeaderSection";

import * as variables from "../../styles/variables";

export default function NotFoundPage() {
  return (
    <>
      <HeaderSection page={"not-found"} title={"Stranica nije pronađena"} />
      <div
        style={{
          background: `${variables.DARK_GREY}`,
          width: "100%",
          height: "100px",
        }}
      />
    </>
  );
}
